import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculatePoolCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) return undefined;

  const { pool } = improvementsForTransaction;
  const zipCode = identification.address.PostalCode;

  if (!pool || isUndefined(pool.quality) || isUndefined(zipCode) || isUndefined(pool.area)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getPoolCost({
    hasFeature: ORDER_FEATURES.pool.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(pool.area),
    quality: pool?.quality,
    zipCode,
  });
};

export const { selectPoolCost, selectZipOnlyPoolCost, selectPoolCosts, selectPoolCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculatePoolCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectPoolCost',
      zipOnly: 'selectZipOnlyPoolCost',
      costs: 'selectPoolCosts',
      display: 'selectPoolCostDisplay',
    },
  });
